<template>
  <div class="v-solution-card">
    <div
      class="v-solution-card__main"
      @click="onClick"
      @mouseover="hover=true"
      @mouseleave="hover=false">

      <div
        v-if="imageUrl"
        class="v-solution-card__image"
        :class="{'v-solution-card__masked-image': imageMask}">
        <img
          class="v-solution-card__img"
          v-if="imageUrl.length"
          :src="imageUrl"
          alt="" />
      </div>
      <div class="v-solution-card__heading">
        <div class="v-solution-card__name"> {{ name }}</div>


        <div class="v-solution-card__effect">
          <div class="v-solution-card__effect-value">
            {{ effect / 1000 }}
          </div>
          <div class="v-solution-card__effect-legend">
            kW
          </div>

          <template v-if="effect > 4000">*</template>
        </div>

      </div>


      <div class="v-solution-card__connector">

        <div
          class="v-solution-card__connector-count"
          v-if="connectorCount > 1">
          {{ connectorCount }}x
        </div>

        <div class="v-solution-card__type">
          {{ connectorType }}
        </div>
      </div>

      <div class="v-solution-card__spacer">

      </div>

      <div class="v-solution-card__price">
        {{ price | toCurrency }},-
      </div>

      <div
        class="v-solution-card__button"
        v-if="buttonLabel.length">
        <eda-button
          :label="buttonLabel"
          :hover="hover"></eda-button>
      </div>

    </div>


    <div class="v-solution-card__info">
      {{ chargingTime }}
    </div>

    <template v-for="detail in details">
      <div
        class="v-solution-card__info"
        v-bind:key="detail.heading">
        <v-click-modal
          :label="detail.label"
          :heading="detail.heading"
          :items="detail.items"
          :annotations="detail.annotations">
        </v-click-modal>
      </div>
    </template>

  </div>

</template>

<script>
import EdaButton from "./vButton";
import vClickModal from "./vClickModal";

export default {
  name: "VCardSolution",
  components: {
    EdaButton,
    vClickModal
  },

  props: {
    name: { type: String, default: "" },
    connectorType: { type: String, default: "" },
    effect: { type: Number, default: 0 },
    connectorCount: { type: Number, default: 0 },
    connectorEffects: {
      type: Object, default: function () {
      }
    },
    selected: { type: Boolean, default: false },
    chargingTime: { type: String, default: "" },
    buttonLabelDefault: { type: String, default: "" }, object: {
      type: Object, default: function () {
        return {};
      }
    },
    onClick: {
      type: Function, default: function () {
        return false;
      }
    },

    type: { type: String, default: "button" },
    price: { type: Number, default: 0 },
    imageUrl: { type: String, default: "" },
    imageMask: { type: Boolean, default: false },
    images: {
      type: Object, default: function () {
        return {};
      }
    },
    deliveryFromDate: {
      type: Object, default: function () {
        return {};
      }
    },
    details: {
      type: Array, default: function () {
        return [];
      }
    },

  },
  data: function () {
    return {
      hover: false,
      buttonLabel: this.buttonLabelDefault ? this.buttonLabelDefault : "",
    };
  },
  computed: {
    toggleLabel() {
      return this.selected ?
        this.$t("genericCard.toggleLabel.added") :
        this.$t("genericCard.toggleLabel.add");
    },
  }

};
</script>

<style lang="scss">

//noinspection CssUnknownTarget
@import '~@/scss/main.scss';

.v-solution-card {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  &__main {
    min-height: 1px;
    flex-grow: 1;
    cursor: pointer;
    text-align: center;
    display: flex;
    background-color: $pane-color;
    flex-direction: column;
    align-items: center;
    padding: 1em 1em 1.5em 1em;

    @include media("<desktop") {
      padding: 1em 1em 1.5em 1em;
    }
  }

  &__image {

    min-height: 1px; /* to fix IE flexbox image sizing bug */
    width: 100%;
    margin-bottom: -30%;
  }

  &__img {
    width: 100%;
    height: 100%;
  }

  &__heading {
    display: flex;

    line-height: 1;
    align-items: center;
    justify-content: center;
    padding: 2.25em 0 0.25em 0;
    width: 100%;
    background-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, .92), rgba(255, 255, 255, .99), white);
    @include media("<desktop") {
      flex-direction: column
    }
  }

  &__specification {

    line-height: 1;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  &__effect {
    padding: .25em .5em .25em;
    justify-content: space-between;
    display: flex;

    @include media("<desktop") {
      padding: .5em 0;
      flex-direction: row;
    }

  }

  &__connector {
    font-size: 0.8em;
    justify-content: space-between;
    padding: .5em .1em;
    display: flex;
    align-items: flex-end;
    @include media("<desktop") {

      padding: .1em .25em;

    }
  }

  &__connector:nth-child(2) {
    padding-left: .5em;
  }

  &__connector-count {
    color: $primary-color;
    font-weight: bold;
    padding-right: .25em;

  }

  &__effect {
    display: flex;
    align-items: flex-end;
    color: $primary-color;
  }

  &__effect-legend {
    font-size: .75em;
    color: $primary-color;
  }

  &__type {
    text-align: left;
  }

  &__charging-time {

    background-color: white;
    padding: 0.25em 0;
    font-weight: 300;
    font-size: 0.9em;
    color: $dim-color;
    width: 100%;
    position: relative;
  }

  &__info {
    // position: relative;
    background-color: $pane-color;
    border-top: 1px solid #f1f1f1;
    padding: .75em 0.5em;

    font-size: 0.75em;
    text-align: center;
    color: $dim-color;
  }

}

.v-solution-card__price {
  padding: 0.5em 0 0.5em;
  font-size: 0.8em;
  font-weight: 600;
}

.v-solution-card__button {
  flex-grow: 1;
  padding-top: 0.75em;
}

.v-solution-card__toggle {
  padding-top: 0.75em;
}

</style>
